<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="expand-transition"
  >
    <v-row
      justify="center"
      fluid
      fill-height
      class="dialog-video-player"
    >
      <v-col :cols="expand ? 9 : 12"
        class="video-player-container ma-0"
      >
        <v-row align="center" class="ma-0">
          <video
            id="video-player"
            ref="videoPlayer"
            class="video-js"
            >
          </video>
        </v-row>
        <v-overlay v-if="!loaded" opacity="1" color="black" light absolute>
          <v-progress-circular indeterminate size="64" color="white"></v-progress-circular>
        </v-overlay>

        <v-btn
          v-show="!expand"
          absolute
          fab
          top
          right
          small
          color="grey lighten-2"
          class="mt-8"
          @click="toggleInformation"
        >
          <v-icon>menu_open</v-icon>
        </v-btn>

        <v-btn
          v-show="!expand"
          absolute
          fab
          top
          left
          small
          color="grey lighten-2"
          class="mt-8"
          @click="close"
        >
          <v-icon>close</v-icon>
        </v-btn>

      </v-col>
      <v-col
        v-show="expand"
        class="video-player-information"
      >
        <h3 class="display-1 font-weight-regular my-3">{{ video.name }}</h3>
        <v-divider></v-divider>
        <p class="body-1 font-weight-light mt-8">{{ video.description }}</p>

        <v-bottom-navigation
          class="video-player-actions"
        >
          <v-btn @click="close">
            <span>{{ $t('video-player.buttons.back') }}</span>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn @click="toggleFavorite" :loading="saving_favorite">
            <span>{{ $t('video-player.buttons.favorite') }}</span>
            <v-icon v-if="favorite" color="red lighten-1">favorite</v-icon>
            <v-icon v-else>favorite_outline</v-icon>
          </v-btn>
          <v-btn @click="toggleInformation">
            <span>{{ $t('video-player.buttons.close-menu') }}</span>
            <v-icon>menu</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<style lang="scss">
.dialog-video-player {
  margin: 0;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  overflow-y: hidden;
  background-color: #Fff;
  .video-player-container {
    background-color: #000000;
    position: relative;
    > .row {
      height: 100%;
      max-height: 100%;
    }
  }
  .video-player-information {
    position: relative;
    > p {
      max-height: 80vh;
    }
    .video-player-actions {
      position: absolute;
      bottom: 0;
    }
  }
}
</style>

<script>

import { getUrlVideo } from '@/store/storage'
import { incrementView } from '@/store/module/video'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  data: () => ({
    expand: true,
    dialog: true,
    saving_favorite: false,
    loaded: false,
    player: null
  }),
  props: {
    video: null,
  },
  mounted() {
    this.loadVideo()
  },
  created() {
    this.$store.dispatch('togglePlayer', true)
  },
  destroyed() {
    this.$store.dispatch('togglePlayer', false)
  },
  computed: {
    favorite() {
      this.savedFavorite()
      return this.$store.getters.user.favorites.includes(this.video.id)
    }
  },
  methods: {
    toggleInformation() {
      this.expand = !this.expand
    },
    close() {
      this.$emit('close')
    },
    savedFavorite() {
      this.saving_favorite = false
    },
    toggleFavorite() {
      this.saving_favorite = true
      this.$emit('toggleFavorite')
    },
    loadVideo() {
      this.player = videojs(
        this.$refs.videoPlayer, {
          controls: true,
          autoplay: true,
          preload: 'none',
          width: '100%',
          aspectRatio: '16:9'
        }
      )

      getUrlVideo(this.video.video).then(url => {
        this.player.src({ src: url })
        this.loaded = true

        incrementView(this.video.id)
      })
    }
  }
}

</script>
